import { Chart } from 'primereact/chart'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import reportProcessor from '../processor/reportProcessor'

const corlorOpacity = [
  'rgba(255, 99, 132, 0.2)',
  'rgba(255, 159, 64, 0.2)',
  'rgba(255, 205, 86, 0.2)',
  'rgba(75, 192, 192, 0.2)',
  'rgba(54, 162, 235, 0.2)',
  'rgba(153, 102, 255, 0.2)',
  'rgba(201, 203, 207, 0.2)',
  'rgba(0, 188, 212, 0.2)',
  'rgba(0, 150, 136, 0.2)',
  'rgba(96, 125, 139, 0.2)',
]
function Home() {
  const [xepLoai, setXepLoai] = useState([])
  const [nam, setNam] = useState([])
  const [tongSo, setTongSo] = useState({})
  const khoaThiId = useSelector((item) => item.khoaThi.id)
  const getTongSo = async () => {
    const rs = await reportProcessor.tongSo(khoaThiId)
    setTongSo(rs)
  }
  const getXepLoai = async () => {
    const rs = await reportProcessor.xepLoai({ khoaThiId })
    setXepLoai(rs)
  }
  useEffect(async () => {
    const rs = await reportProcessor.nam()
    setNam(rs)
  }, [])
  useEffect(() => {
    getTongSo()
    getXepLoai()
  }, [khoaThiId])
  const barData = {
    labels: nam.map((item) => item.name),
    datasets: [
      {
        label: '',
        data: nam.map((item) => item.tongSo),
        backgroundColor: corlorOpacity,
      },
    ],
  }
  const pieData = {
    labels: xepLoai.map((item) => item.name),
    datasets: [
      {
        data: xepLoai.map((item) => item.tongSo),
        backgroundColor: ['#E91E63', '#2196F3', '#FBC02D'],
      },
    ],
  }
  return (
    <div className="layout-dashboard">
      <div className="grid">
        <div className="col-12 md:col-4">
          <div className="card widget-overview-box widget-overview-box-3">
            <b className="m-0 p-0 text-sm">Tổng số văn bằng</b>
            <div className="flex justify-content-center">
              <div className="overview-detail flex justify-content-center">
                <div className="overview-badge flex justify-content-center align-items-center">
                  <span>{tongSo.tong || '0'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 md:col-4">
          <div className="card widget-overview-box widget-overview-box-2">
            <b className="m-0 p-0 text-sm">Số văn bằng đã cấp phát</b>
            <div className="flex justify-content-center">
              <div className="overview-detail flex justify-content-center">
                <div className="overview-badge flex justify-content-center align-items-center">
                  <span>{tongSo.daCap || '0'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 md:col-4">
          <div className="card widget-overview-box widget-overview-box-1">
            <b className="m-0 p-0 text-sm">Số văn bằng chưa cấp phát</b>
            <div className="flex justify-content-center">
              <div className="overview-detail flex justify-content-center">
                <div className="overview-badge flex justify-content-center align-items-center">
                  <span>{tongSo.chuaCap || '0'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col-12 md:col-8">
          <div className="card">
            <b className="m-0 p-0 text-sm">Tổng số văn bằng 10 năm gần đây</b>
            <Chart type="bar" data={barData} />
          </div>
        </div>
        <div className="col-12 md:col-4">
          <div className="card">
            <b className="m-0 p-0 text-sm">Học lực theo khoá thi</b>
            <Chart type="pie" data={pieData} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default withRouter(Home)
